import script from "./FileReader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileReader.vue?vue&type=script&setup=true&lang=ts"

import "./FileReader.vue?vue&type=style&index=0&id=71578c5c&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71578c5c"]])

export default __exports__